import { render } from "./MaterialSnackbar.vue?vue&type=template&id=7deb617c&scoped=true"
import script from "./MaterialSnackbar.vue?vue&type=script&lang=js"
export * from "./MaterialSnackbar.vue?vue&type=script&lang=js"

import "./MaterialSnackbar.vue?vue&type=style&index=0&id=7deb617c&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7deb617c"]])

export default __exports__